import React from 'react';
import { ClosureEvent } from '../../types/inspection';
import { CheckCircle2, XCircle, Shield, Archive, ArrowLeftRight } from 'lucide-react';

interface InspectionHistoryTimelineProps {
  events: ClosureEvent[];
}

export const InspectionHistoryTimeline: React.FC<InspectionHistoryTimelineProps> = ({ events }) => {
  if (events.length === 0) {
    return (
      <div className="p-8 text-center">
        <p className="text-xs text-slate-400">No inspection history available</p>
      </div>
    );
  }

  const iconMap = {
    inspection: <CheckCircle2 className="w-4 h-4 text-sky-400" />,
    verification: <Shield className="w-4 h-4 text-emerald-400" />,
    closure: <Archive className="w-4 h-4 text-emerald-400" />,
    returned_to_vendor: <ArrowLeftRight className="w-4 h-4 text-rose-400" />,
  };

  const colorMap = {
    inspection: 'border-sky-500/30',
    verification: 'border-emerald-500/30',
    closure: 'border-emerald-500/30',
    returned_to_vendor: 'border-rose-500/30',
  };

  return (
    <div className="space-y-4">
      {events.map((event, idx) => (
        <div key={event.event_id} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className={`p-2 rounded-full border ${colorMap[event.event_type]} bg-slate-900`}>
              {iconMap[event.event_type]}
            </div>
            {idx < events.length - 1 && <div className="w-px h-full bg-slate-800 mt-1" />}
          </div>
          <div className="pb-4 flex-1">
            <p className="text-xs font-semibold text-slate-200">{event.description}</p>
            <div className="flex items-center gap-3 mt-1">
              <span className="text-[10px] text-slate-500">By: {event.performed_by}</span>
              <span className="text-[10px] text-slate-500">{new Date(event.performed_at).toLocaleString()}</span>
            </div>
            {event.metadata && (
              <div className="mt-1 text-[10px] text-slate-400">
                {Object.entries(event.metadata).map(([k, v]) => (
                  <span key={k} className="mr-3">{k}: {v}</span>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
